import 'whatwg-fetch';
import 'core-js/features/promise';
import 'core-js/features/object';
import 'core-js/features/array';
import 'core-js/features/map';
if (!global.Promise) global.Promise = require('promise-polyfill');
